export default __webpack_public_path__ + "media/images/favicon-c4c78a139fc55f6ff64fcfe38cf377df.svg";